import React from "react";

import useRule from "../../../../hooks/super/useRule";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function DeleteCustomRuleModal({ open, handleClose, ruleID, deleted, removeFlag }) {
  const { deleteCustomRule, restoreCustomRule } = useRule();
  const [busy, setBusy] = React.useState(false);

  const isRestore = deleted && !removeFlag;
  const title = removeFlag
    ? "Permanently remove custom rule?"
    : isRestore
    ? "Restore custom rule?"
    : "Delete custom rule?";
  const body = removeFlag
    ? "This rule will be permanently removed and cannot be recovered."
    : isRestore
    ? "The rule will be reactivated."
    : "The rule will be marked deleted. You can restore it later.";
  const variant = removeFlag || !isRestore ? "danger" : "success";
  const submit = removeFlag ? "Remove permanently" : isRestore ? "Restore" : "Delete";

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (isRestore) await restoreCustomRule(ruleID);
      else await deleteCustomRule(ruleID, removeFlag);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant={variant}
      title={title}
      body={body}
      items={ruleID ? [{ id: ruleID, title: `Rule ${ruleID}` }] : []}
      submitLabel={submit}
      loading={busy}
    />
  );
}

export default DeleteCustomRuleModal;
